import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Sprint, _WorkActivity } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
type FilterActivities = {
    IDWorkActivityGroup?: number | null;
}

type FilterSprints = {
    IDProject?: number | null;
}

export const useSprintBoard = () => {

    const sprintBean = useDataBean(_Sprint);
    const activityBean = useDataBean(_WorkActivity);

    const [sprints, setSprints] = useState<any[]>([]);
    const [backlog, setBacklog] = useState<any[]>([]);
    const [sprintActivities, setSprintActivities] = useState<Record<number, any[]>>({});
    const [filterActivities, setFilterActivities] = useState<Partial<FilterActivities>>({});
    const [filterSprints, setFilterSprints] = useState<Partial<FilterSprints>>({});

    const paginadorSprint = usePaginator();
    const paginadorWorks = usePaginator();
    const paginadorSprintWorks = usePaginator();

    const [expanded, setExpanded] = useState<Record<number, boolean>>({});

    const loadSprints = (filters: Partial<FilterSprints> = filterSprints, page: number = paginadorSprint.page) => {
        let props: any = {
            State: null,
        }

        if (filters.IDProject) {
            props = {
                ...props,
                IDProject: filters.IDProject
            }
        }

        sprintBean.instance.getSprintRender(page, 2, props).then(
            (resp) => {
                paginadorSprint.setPages(resp.NumberOfPages);
                paginadorSprint.setRecords(resp.NumberOfPages * (15));
                setSprints(resp.List)
            }
        ).catch((err) => toast.error(err));
    }

    const renderSubtaskInfo = (task: any) => {
        if (task.DataBeanProperties.TotalSubtasks) {
            const render =
                ` 
            <div>            
            <strong>Procentaje de Finalización: </strong><small>%${task.DataBeanProperties.ProgressPercent ?? 0}</small><br />
            <strong>${task.DataBeanProperties.DoneSubtasks}</strong><small> de </small><strong>${task.DataBeanProperties.TotalSubtasks}</strong><small> subtareas completadas</small><br />            
            </div>
            `
            return render;
        } else {
            return "No Tiene Sub-Tareas";
        }
    }

    const renderGroupsListInfo = (groups: any[]) => {
        if (groups.length > 0) {
            const items = groups
                .map(group => `<li>${group}</li>`)
                .join("");

            return `<ul>${items}</ul>`;
        } else {
            return "N/P";
        }
    }

    const loadSprintAcxtivities = (sprintId: number) => {
        let props: any = {
            IDSprint: sprintId,
            State: 1,
        }

        if (filterActivities.IDWorkActivityGroup) {
            props = {
                ...props,
                IDWorkActivityGroup: filterActivities.IDWorkActivityGroup
            }
        }

        activityBean.instance.getWorkActivityRender(paginadorSprintWorks.page, 10, props).then(
            (resp) => {
                paginadorSprintWorks.setPages(resp.NumberOfPages);
                paginadorSprintWorks.setRecords(resp.NumberOfPages * (10));
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityActivity = `${element.DataBeanProperties.WorkActivityCode ?? "N/P"}` + " " + `${element.DataBeanProperties.Name ?? "N/P"}`;
                    element.DataBeanProperties.EmployeEntity = element.DataBeanProperties.IDEmployee ? `${element.DataBeanProperties.AccountNit ?? "S/D"} - ${element.DataBeanProperties.AccountFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.ReporterEntity = element.DataBeanProperties.IDReporter ? `${element.DataBeanProperties.AccountReporterNit ?? "S/D"} - ${element.DataBeanProperties.AccountReporterFullName ?? ""}` : "N/P";
                    element.DataBeanProperties.SolverEntity = element.DataBeanProperties.IDSolver ? `${element.DataBeanProperties.AccountSolverNit ?? "S/D"} - ${element.DataBeanProperties.AccountSolverFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.StatusEntity = element.DataBeanProperties.IDWorkActivityStatuses ? `${element.DataBeanProperties.StatusesName} (${element.DataBeanProperties.StatusesCategory})` : "N/A";
                    element.DataBeanProperties.Progress = renderSubtaskInfo(element);
                    element.DataBeanProperties.AsignedGroups = renderGroupsListInfo(element.DataBeanProperties.Groups);
                });
                setSprintActivities(prev => ({
                    ...prev,
                    [sprintId]: resp.List
                }));
            }
        ).catch((err) => toast.error(err));
    }

    const loadBacklog = () => {
        let props: any = {
            State: 1,
        }

        if (filterActivities.IDWorkActivityGroup) {
            props = {
                ...props,
                IDWorkActivityGroup: filterActivities.IDWorkActivityGroup
            }
        }
        activityBean.instance.getWorkActivityRender(paginadorWorks.page, 10, props, true).then(
            (resp) => {
                paginadorWorks.setPages(resp.NumberOfPages);
                paginadorWorks.setRecords(resp.NumberOfPages * (10));
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityActivity = `${element.DataBeanProperties.WorkActivityCode ?? "N/P"}` + " " + `${element.DataBeanProperties.Name ?? "N/P"}`;
                    element.DataBeanProperties.EmployeEntity = element.DataBeanProperties.IDEmployee ? `${element.DataBeanProperties.AccountNit ?? "S/D"} - ${element.DataBeanProperties.AccountFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.ReporterEntity = element.DataBeanProperties.IDReporter ? `${element.DataBeanProperties.AccountReporterNit ?? "S/D"} - ${element.DataBeanProperties.AccountReporterFullName ?? ""}` : "N/P";
                    element.DataBeanProperties.SolverEntity = element.DataBeanProperties.IDSolver ? `${element.DataBeanProperties.AccountSolverNit ?? "S/D"} - ${element.DataBeanProperties.AccountSolverFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.StatusEntity = element.DataBeanProperties.IDWorkActivityStatuses ? `${element.DataBeanProperties.StatusesName} (${element.DataBeanProperties.StatusesCategory})` : "N/A";
                    element.DataBeanProperties.Progress = renderSubtaskInfo(element);
                    element.DataBeanProperties.AsignedGroups = renderGroupsListInfo(element.DataBeanProperties.Groups);
                });
                setBacklog(resp.List);
            }
        ).catch(err => toast.error(err));
    }

    const refreshAll = async () => {

        await loadSprints();
        await loadBacklog();

    };

    const toggleSprint = (id: number) => {

        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));

    };

    return {
        sprints,
        backlog,
        sprintActivities,
        filterActivities,
        setFilterActivities,
        filterSprints,
        setFilterSprints,

        paginadorSprint,
        paginadorWorks,
        paginadorSprintWorks,

        expanded,
        toggleSprint,

        refreshAll,
        loadSprints,
        loadBacklog,
        loadSprintAcxtivities,
    };
};
